module.exports = __webpack_public_path__ + "img/cart-category-sp.42d210f2.png";